import { AfterViewInit, ChangeDetectionStrategy, Component, Input, ViewChild } from "@angular/core";
import { AbstractControl } from "@angular/forms";
import { MatTabGroup } from "@angular/material/tabs";
import { FieldType, FormlyFieldConfig } from "@ngx-formly/core";
import { FormlyFieldProps } from "@ngx-formly/material/form-field";
import { UiSchemaConfigService } from "@vp/formly/ui-schema-config";

/**
 * Returns the tab label.
 *
 * - Uses the container label when there is only one tab.
 * - Uses each tab's own label when there are multiple tabs.
 * - Falls back to the tab index when labels are hidden or missing.
 */
export const getLabel = (fieldProps: FormlyFieldProps, tab: FormlyFieldConfig, index: number) => {
  const fallbackLabel = index + 1;
  if (fieldProps.hideLabel === true) return fallbackLabel;

  return getTabLabel(fieldProps, tab) ?? fallbackLabel;
};
const getTabLabel = (fieldProps: FormlyFieldProps, tab: FormlyFieldConfig) => {
  const isSingleTabGroup = tab.parent?.fieldGroup?.length === 1;
  if (isSingleTabGroup) {
    return fieldProps.label ?? tab.props?.label;
  }

  return tab.props?.label;
};

@Component({
  selector: "lib-formly-tabs-layout-type",
  standalone: false,
  templateUrl: "./formly-tabs-layout-type.component.html",
  styleUrls: ["./formly-tabs-layout-type.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlyTabsLayoutTypeComponent extends FieldType implements AfterViewInit {
  label = getLabel;
  trackById = this.getTrackByFn.bind(this);

  constructor(private service: UiSchemaConfigService) {
    super();
  }

  @Input() selectedIndex = 0;

  @ViewChild(MatTabGroup) tabGroup?: MatTabGroup;

  ngAfterViewInit(): void {
    this.tabGroup?.selectedIndexChange.subscribe((index: number) => {
      this.service.tabChanged(index);
    });
  }

  getTrackByFn(index: number, item: any) {
    return item.id ?? index;
  }

  // This is NOT performant, but I couldnt find another way to to do this.
  isValid(index: number): boolean {
    const key = Object.keys(this.form.controls)[index];
    const control = (this.form.controls as { [key: string]: AbstractControl<any, any> })[key];
    if (control) {
      return !(this.form.enabled === true && control.status === "INVALID");
    }
    return true;
  }
}
